module.exports = __webpack_public_path__ + "static/media/gallery-10.565b7751.jpg";